export default __webpack_public_path__ + "static/media/partner-program-keyvisual.7c5ddce2.svg";